import { ItemMappingImportPage } from "@/features/item-mapping/pages/ItemMappingImportPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/item-mapping/import")({
	component: ItemMappingImportPage,
});
